import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ComicCardProps {
  slug: string;
  title: string;
  cover: string;
  category: string;
  status: 'ongoing' | 'completed';
  rating: number;
  chaptersCount: number;
  featured?: boolean;
}

export default function ComicCard({ slug, title, cover, category, status, rating, chaptersCount, featured }: ComicCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/comic/${slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          title={`${title} - 八仔漫画网免费在线阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute top-2 right-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            status === 'ongoing'
              ? 'bg-accent-500 text-white'
              : 'bg-secondary-500 text-white'
          }`}>
            {status === 'ongoing' ? t('comic.ongoing') : t('comic.completed')}
          </span>
        </div>
        <div className="absolute bottom-2 left-2 right-2">
          <span className="text-xs text-white/80">{category}</span>
        </div>
      </div>

      <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
        {title}
      </h3>

      <div className="flex items-center gap-2 mt-1">
        <div className="flex items-center gap-0.5">
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
          </div>
          <span className="text-xs text-foreground-600">{rating}</span>
        </div>
        <span className="text-xs text-foreground-400">·</span>
        <span className="text-xs text-foreground-500">{chaptersCount}{t('comic.chapters')}</span>
      </div>
    </Link>
  );
}